(() => {
  function initializePth253dPage() {
    const root = document.querySelector('.pth253d-root');
    if (!root || root.dataset.pth253dInitialized === 'true') return;
    root.dataset.pth253dInitialized = 'true';

    const price = root.querySelector('[data-pth253d-price]');
    const compareAt = root.querySelector('[data-pth253d-compare-at]');
    const saleLabel = root.querySelector('[data-pth253d-sale-label]');
    const status = root.querySelector('[data-pth253d-status]');
    const addButton = root.querySelector('[data-pth253d-add-to-cart]');
    const quantityButtons = [...root.querySelectorAll('[data-quantity]')];
    const mediaButtons = [...root.querySelectorAll('[data-pth253d-media]')];
    const mainImage = root.querySelector('[data-pth253d-main-image]');
    const videoViewport = root.querySelector('[data-pth253d-video-viewport]');
    const videoPrevious = root.querySelector('[data-pth253d-video-prev]');
    const videoNext = root.querySelector('[data-pth253d-video-next]');
    const reviewCarousel = root.querySelector('[data-pth253d-review-carousel]');
    let selectedQuantity = 1;

    function setStatus(message, state = '') {
      status.textContent = message;
      status.className = ('pth253d-status ' + state).trim();
    }

    quantityButtons.forEach((button) => {
      button.addEventListener('click', () => {
        selectedQuantity = Number(button.dataset.quantity);
        quantityButtons.forEach((item) => {
          const isSelected = item === button;
          item.classList.toggle('is-selected', isSelected);
          item.setAttribute('aria-checked', String(isSelected));
        });
        price.textContent = button.dataset.offerTotal;
        if (compareAt) compareAt.textContent = button.dataset.offerRegular;
        if (saleLabel) saleLabel.textContent = button.dataset.offerPercent;
        setStatus('');
      });
    });

    mediaButtons.forEach((button) => {
      button.addEventListener('click', () => {
        if (!mainImage) return;
        mainImage.src = button.dataset.fullUrl;
        mainImage.alt = button.dataset.alt || mainImage.alt;
        mediaButtons.forEach((item) => {
          const isActive = item === button;
          item.classList.toggle('is-active', isActive);
          item.setAttribute('aria-pressed', String(isActive));
        });
      });
    });

    if (videoViewport && videoPrevious && videoNext) {
      const updateVideoControls = () => {
        const maxScroll = videoViewport.scrollWidth - videoViewport.clientWidth;
        videoPrevious.disabled = videoViewport.scrollLeft <= 2;
        videoNext.disabled = videoViewport.scrollLeft >= maxScroll - 2;
      };

      const moveVideos = (direction) => {
        const firstCard = videoViewport.querySelector('.pth253d-video-card');
        if (!firstCard) return;
        const cardWidth = firstCard.getBoundingClientRect().width;
        const gap = Number.parseFloat(getComputedStyle(videoViewport.querySelector('.pth253d-video-carousel')).gap) || 0;
        const visibleCards = window.matchMedia('(max-width: 640px)').matches ? 1 : 2;
        videoViewport.scrollBy({ left: direction * (cardWidth + gap) * visibleCards, behavior: 'smooth' });
      };

      videoPrevious.addEventListener('click', () => moveVideos(-1));
      videoNext.addEventListener('click', () => moveVideos(1));
      videoViewport.addEventListener('scroll', updateVideoControls, { passive: true });
      window.addEventListener('resize', updateVideoControls);
      requestAnimationFrame(updateVideoControls);
    }

    root.querySelectorAll('[data-pth253d-video-player]').forEach((player) => {
      const video = player.querySelector('video');
      const toggle = player.querySelector('[data-pth253d-video-toggle]');
      if (!video || !toggle) return;

      const updateToggle = () => {
        const isPlaying = !video.paused && !video.ended;
        player.classList.toggle('is-playing', isPlaying);
        toggle.setAttribute('aria-label', isPlaying ? 'Pause customer video' : 'Play customer video');
      };

      toggle.addEventListener('click', () => {
        if (video.paused || video.ended) {
          root.querySelectorAll('[data-pth253d-video-player] video').forEach((otherVideo) => {
            if (otherVideo !== video) otherVideo.pause();
          });
          video.play().catch(() => updateToggle());
        } else {
          video.pause();
        }
      });

      video.addEventListener('play', updateToggle);
      video.addEventListener('pause', updateToggle);
      video.addEventListener('ended', updateToggle);
      updateToggle();
    });

    if (reviewCarousel) {
      const reviewSlides = [...reviewCarousel.querySelectorAll('[data-pth253d-review-slide]')];
      const reviewDots = [...reviewCarousel.querySelectorAll('[data-pth253d-review-dot]')];
      const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      let activeReviewIndex = Math.max(0, reviewSlides.findIndex((slide) => slide.classList.contains('is-active')));
      let reviewTimer;

      const setActiveReview = (index) => {
        activeReviewIndex = (index + reviewSlides.length) % reviewSlides.length;
        reviewSlides.forEach((slide, slideIndex) => {
          const isActive = slideIndex === activeReviewIndex;
          slide.classList.toggle('is-active', isActive);
          slide.setAttribute('aria-hidden', String(!isActive));
        });
        reviewDots.forEach((dot, dotIndex) => {
          dot.setAttribute('aria-current', String(dotIndex === activeReviewIndex));
        });
      };

      const stopReviewRotation = () => {
        if (reviewTimer) {
          window.clearInterval(reviewTimer);
          reviewTimer = undefined;
        }
      };

      const startReviewRotation = () => {
        stopReviewRotation();
        if (reviewSlides.length < 2 || reduceMotion) return;
        reviewTimer = window.setInterval(() => setActiveReview(activeReviewIndex + 1), 5000);
      };

      if (reviewSlides.length && reviewDots.length === reviewSlides.length) {
        setActiveReview(activeReviewIndex);
        reviewDots.forEach((dot, index) => {
          dot.addEventListener('click', () => {
            setActiveReview(index);
            startReviewRotation();
          });
        });
        reviewCarousel.addEventListener('mouseenter', stopReviewRotation);
        reviewCarousel.addEventListener('mouseleave', startReviewRotation);
        reviewCarousel.addEventListener('focusin', stopReviewRotation);
        reviewCarousel.addEventListener('focusout', (event) => {
          if (!reviewCarousel.contains(event.relatedTarget)) startReviewRotation();
        });
        reviewCarousel.addEventListener('touchstart', stopReviewRotation, { passive: true });
        reviewCarousel.addEventListener('touchend', startReviewRotation, { passive: true });
        reviewCarousel.addEventListener('touchcancel', startReviewRotation, { passive: true });
        startReviewRotation();
      }
    }

    addButton?.addEventListener('click', async () => {
      const variantId = Number(root.dataset.variantId);
      if (!variantId || addButton.disabled) return;

      addButton.disabled = true;
      setStatus('Adding to cart...');

      try {
        const response = await fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: variantId, quantity: selectedQuantity }] })
        });
        const data = await response.json();
        if (!response.ok) throw new Error(data.description || data.message || 'Unable to add this item to cart.');

        const unitLabel = selectedQuantity === 1 ? 'unit' : 'units';
        setStatus(String(selectedQuantity) + ' ' + unitLabel + ' added to cart.', 'is-success');
        document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
      } catch (error) {
        setStatus(error.message || 'Unable to add this item to cart. Please try again.', 'is-error');
      } finally {
        addButton.disabled = false;
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializePth253dPage, { once: true });
  } else {
    initializePth253dPage();
  }
})();
